if(!customElements.get('add-ons-component-v2')) {
  customElements.define(
    'add-ons-component-v2',
    class AddOnsComponentV2 extends HTMLElement {
      constructor() {
        super();
        this.mainProductId = null;
        this.selectedAddons = new Map();
        this.mainProductButton = null;
        this.originalButtonText = '';
        this.mainProductPrice = 0;
        this.isIntercepted = false;
        this.isSubmitting = false;
        this.isProgrammaticChange = false;
      }
    
      connectedCallback() {
        this.mainProductId = this.dataset.mainProductId;
        
        if (!this.mainProductId) {
          console.error('Addons Manager V2 missing required data-main-product-id');
          return;
        }
        
        this.findAddonSections();
        this.setupEventListeners();
        this.getMainProductButton();
        this.getMainProductPrice();
        this.interceptProductForm();
        this.updateButtonText();
        
        this.productInfoLoadedHandler = () => {
          this.isIntercepted = false;
          this.getMainProductButton();
          this.getMainProductPrice();
          this.interceptProductForm();
          this.updateButtonText();
        };
        document.addEventListener('product-info:loaded', this.productInfoLoadedHandler);
      }

      // Custom: Addon Sets
      // Stop listening once a product swap replaces this component, as v3 does
      disconnectedCallback() {
        if (this.productInfoLoadedHandler) {
          document.removeEventListener('product-info:loaded', this.productInfoLoadedHandler);
        }
      }
      
      findAddonSections() {
        this.addonSections = this.querySelectorAll('[data-addon-type]');
      }
    
      setupEventListeners() {
        this.querySelectorAll('.add-ons-v2__checkbox').forEach(checkbox => {
          checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));
        });
      }
    
      handleCheckboxChange(event) {
        if (this.isProgrammaticChange) return;
        
        const checkbox = event.target;
        const isChecked = checkbox.checked;
        const isClearSelection = checkbox.dataset.clearSelection === 'true';
        const section = checkbox.closest('[data-addon-type]');
        const addonType = section?.dataset.addonType;
        
        if (!addonType) return;
        
        // Prevent unchecking none variant
        if (!isChecked) {
          const checkedCount = section.querySelectorAll('.add-ons-v2__checkbox:checked').length;
          if (checkedCount === 0) {
            event.preventDefault();
            checkbox.checked = true;
            return;
          }
        }
        
        if (isChecked) {
          this.uncheckOtherCheckboxes(section, checkbox);
        }
        
        if (isChecked && !isClearSelection) {
          const addonData = {
            variantId: checkbox.dataset.productId,
            price: parseFloat(checkbox.dataset.productPrice) || 0,
            title: checkbox.dataset.addonsAttribute || '',
            productSetImage: checkbox.dataset.productSetImage || null,
            productHandle: checkbox.dataset.productHandle || ''
          };
          
          this.selectedAddons.set(addonType, addonData);
          this.updateSectionHeader(section, addonData);
          
          const enableImageSwitching = section.dataset.enableImageSwitching === 'true';
          if (enableImageSwitching) {
            this.hideAddonImages();
            this.showAddonImages(checkbox);
          }
        } else {
          this.selectedAddons.delete(addonType);
          this.updateSectionHeader(section, null);
          
          const enableImageSwitching = section.dataset.enableImageSwitching === 'true';
          if (enableImageSwitching) {
            this.hideAddonImages();
          }
        }
        
        this.updateButtonText();
      }
      
      uncheckOtherCheckboxes(section, currentCheckbox) {
        this.isProgrammaticChange = true;
        section.querySelectorAll('.add-ons-v2__checkbox').forEach(checkbox => {
          if (checkbox !== currentCheckbox) checkbox.checked = false;
        });
        this.isProgrammaticChange = false;
      }
      
      updateSectionHeader(section, addonData) {
        const titleElement = section.querySelector('.add-ons-v2__addon-title');
        const priceElement = section.querySelector('.add-ons-v2__addon-price');
        const linkElement = section.querySelector('.add-ons-v2__product-link');
        
        if (addonData) {
          if (titleElement) titleElement.textContent = addonData.title;
          if (priceElement) {
            const priceValue = (addonData.price / 100).toFixed(2);
            const formattedPrice = typeof formatMoney !== 'undefined' ? 
              formatMoney(priceValue) : `£${priceValue}`;
            priceElement.textContent = `+ ${formattedPrice}`;
          }
          if (linkElement) {
            linkElement.href = addonData.productHandle ? `/products/${addonData.productHandle}` : '#';
            linkElement.classList.remove('hidden');
          }
        } else {
          if (titleElement) titleElement.textContent = '';
          if (priceElement) priceElement.textContent = '';
          if (linkElement) {
            linkElement.href = '#';
            linkElement.classList.add('hidden');
          }
        }
      }
      
      getMainProductButton() {
        this.mainProductButton = document.querySelector('product-form .product-form__submit');
        if (this.mainProductButton) {
          const buttonTextWrapper = this.mainProductButton.querySelector('.button-text-wrapper');
          if (buttonTextWrapper) {
            this.originalButtonText = buttonTextWrapper.innerHTML;
          }
        }
      }
      
      getMainProductPrice() {
        const priceElement = document.querySelector('product-info[data-price-raw]');
        if (priceElement) {
          this.mainProductPrice = parseInt(priceElement.dataset.priceRaw) || 0;
        }
      }
      
      getCurrentProductId() {
        const productInfo = document.querySelector('product-info[data-product-id]');
        return productInfo?.dataset.productId;
      }
      
      getTotalPrice() {
        let total = 0;
        this.selectedAddons.forEach(addon => {
          total += addon.price || 0;
        });
        return total;
      }
      
      formatPriceWithCommas(priceInCents) {
        const priceValue = (priceInCents / 100).toFixed(2);
        const [pounds, pence] = priceValue.split('.');
        const poundsWithCommas = pounds.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return `${poundsWithCommas}.${pence}`;
      }
      
      updateButtonText() {
        if (!this.mainProductButton) this.getMainProductButton();
        if (!this.mainProductButton) return;
        
        const buttonTextWrapper = this.mainProductButton.querySelector('.button-text-wrapper');
        const atbInfoPrices = document.querySelectorAll('.atb-info__price');
        const atbInfoRightPrices = document.querySelectorAll('.atb-info__right-price');
        const currentProductId = this.getCurrentProductId();
        const isMobile = window.innerWidth < 750;

        if (!currentProductId) {
          if (buttonTextWrapper) {
            buttonTextWrapper.textContent = isMobile ? 'ADD TO BASKET' : (this.originalButtonText || 'ADD TO BASKET');
          }
          return;
        }

        if (this.selectedAddons.size === 0) {
          if (buttonTextWrapper) {
            buttonTextWrapper.innerHTML = this.originalButtonText || 'Add to basket';
          }
          const restoredPriceAmount = this.mainProductButton.querySelector('[data-mobile-price-amount]');
          if ((isMobile && restoredPriceAmount) || atbInfoPrices.length || atbInfoRightPrices.length) {
            const priceElement = document.querySelector('product-info[data-price-raw]');
            if (priceElement) {
              const originalPrice = parseInt(priceElement.dataset.priceRaw) || 0;
              const priceWithCommas = this.formatPriceWithCommas(originalPrice);
              const formattedPrice = typeof formatMoney !== 'undefined' ?
                formatMoney(priceWithCommas) : `£${priceWithCommas}`;
              if (isMobile && restoredPriceAmount) restoredPriceAmount.textContent = formattedPrice;
              atbInfoPrices.forEach((el) => { el.textContent = formattedPrice; });
              atbInfoRightPrices.forEach((el) => { el.textContent = formattedPrice; });
            }
          }
          return;
        }

        const combinedPrice = this.mainProductPrice + this.getTotalPrice();
        const priceWithCommas = this.formatPriceWithCommas(combinedPrice);
        const formattedPrice = typeof formatMoney !== 'undefined' ?
          formatMoney(priceWithCommas) : `£${priceWithCommas}`;

        atbInfoPrices.forEach((el) => { el.textContent = formattedPrice; });
        atbInfoRightPrices.forEach((el) => { el.textContent = formattedPrice; });

        if (isMobile) {
          if (buttonTextWrapper) {
            buttonTextWrapper.innerHTML = this.originalButtonText || '';
            const priceAmount = buttonTextWrapper.querySelector('[data-mobile-price-amount]');
            if (priceAmount) priceAmount.textContent = formattedPrice;
            Array.from(buttonTextWrapper.childNodes).forEach((node) => {
              if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) node.remove();
            });
            buttonTextWrapper.append(' Add set to basket');
          }
        } else if (buttonTextWrapper) {
          buttonTextWrapper.textContent = `${formattedPrice} - ADD SET TO BASKET`;
        }
      }
      
      interceptProductForm() {
        if (this.isIntercepted) return;
        
        const productFormElement = document.querySelector('product-form');
        const productForm = productFormElement?.querySelector('form[data-type="add-to-cart-form"]');
        
        if (!productForm) return;
        
        const originalOnSubmitHandler = productFormElement.onSubmitHandler?.bind(productFormElement);
        
        if (!originalOnSubmitHandler) {
          console.warn('Could not find original onSubmitHandler');
          return;
        }
        
        productForm.addEventListener('submit', async (event) => {
          // Custom: Addon Sets
          // A component replaced by a product swap can still hold a listener on the new form
          if (!this.isConnected) return;

          if (this.selectedAddons.size > 0) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            if (this.isSubmitting) return;
            await this.handleFormSubmission(event, productForm);
          } else {
            originalOnSubmitHandler(event);
          }
        }, true);
        
        this.isIntercepted = true;
      }
      
      async handleFormSubmission(event, productForm) {
        try {
          this.isSubmitting = true;
          this.setButtonLoading(true);
          
          const currentProductId = this.getCurrentProductId();
          if (!currentProductId) {
            throw new Error('Current product ID not found');
          }
          
          const formData = new FormData(productForm);
          const mainVariantId = formData.get('id');
          const setQuantity = Math.max(1, parseInt(formData.get('quantity'), 10) || 1);
          const setHelpers = window.AddonSetRelationships;
          const lineUid = setHelpers ? setHelpers.mintLineUid() : null;
          
          if (!mainVariantId) {
            throw new Error('Main product variant ID not found');
          }
          
          // Custom: Addon Sets - ranked by addon type so the cart order does not depend on tick order
          const addonEntries = Array.from(this.selectedAddons.entries());
          const orderedEntries = setHelpers ? setHelpers.orderForAdd(addonEntries) : addonEntries;

          const addonItems = orderedEntries.map(([addonType, addon]) => {
            // Get product tags from addon data first, fallback to checkbox
            const productTags = addon.productTags || this.querySelector(`[data-product-id="${addon.variantId}"]`)?.dataset.productTags;
            const lowestDeliveryCost = productTags && typeof delivery_tabs !== 'undefined' ? 
              delivery_tabs.calculateLowestDeliveryCost(productTags) : null;
            
            // Build properties object
            const properties = {};
            if (lowestDeliveryCost !== null) {
              properties['Lowest Delivery Cost'] = String(lowestDeliveryCost);
            }

            if (lineUid) {
              properties[setHelpers.RELATIONSHIPS_KEY] = setHelpers.buildRelationship(lineUid, addonType);
            }
            
            return {
              id: addon.variantId,
              quantity: setQuantity,
              properties: Object.keys(properties).length > 0 ? properties : undefined
            };
          });
          
          // Get main product's delivery cost
          const productInfo = document.querySelector('product-info[data-product-tags]');
          const mainProductTags = productInfo?.dataset.productTags;
          const mainProductLowestDeliveryCost = mainProductTags && typeof delivery_tabs !== 'undefined' ? 
            delivery_tabs.calculateLowestDeliveryCost(mainProductTags) : null;
          
          const mainProductProperties = {};
          if (mainProductLowestDeliveryCost !== null) {
            mainProductProperties['Lowest Delivery Cost'] = String(mainProductLowestDeliveryCost);
          }

          if (lineUid) {
            mainProductProperties[setHelpers.LINE_UID_KEY] = lineUid;
          }
          
          const items = [
            ...addonItems,
            { 
              id: mainVariantId, 
              quantity: setQuantity,
              properties: Object.keys(mainProductProperties).length > 0 ? mainProductProperties : undefined
            }
          ];
          
          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const sectionsToRender = cart?.getSectionsToRender?.() || [];

          // Custom: Addon Sets
          // Same set already in the cart: reuse its uid so /cart/add.js tops it up (and checks stock)
          if (lineUid) {
            try {
              const currentCart = await setHelpers.fetchCart();
              const composition = setHelpers.buildComposition(
                mainVariantId,
                addonItems.map((addonItem) => addonItem.id)
              );
              const existingSet = setHelpers.findMatchingSet(currentCart, composition, items);

              if (existingSet) {
                setHelpers.retargetSet(items, existingSet.lineUid);
              }
            } catch (error) {
              console.warn('[addon-set] could not check for an existing set', error);
            }
          }
          
          const config = {
            method: 'POST',
            headers: { 
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items,
              sections: sectionsToRender.map(section => section.id).join(','),
              sections_url: window.location.pathname
            })
          };

          const response = await fetch('/cart/add.js', config);
          
          if (!response.ok) {
            throw new Error(`Failed to add items: ${response.status}`);
          }
          
          const result = await response.json();
          
          if (result.status) {
            throw new Error(result.description || 'Failed to add items to cart');
          }
          
          this.selectedAddons.clear();
          this.resetAddonsToDefault();
          
          document.dispatchEvent(new CustomEvent('addon-v2:cart-added', { 
            detail: { mainProductId: currentProductId }
          }));
          
          this.updateButtonText();
          
          if (typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'addon-v2-system',
              productVariantId: mainVariantId,
              cartData: result
            });
          }
          
          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(result);
          }
          
          if (document.querySelector('cart-drawer')) {
            const observer = new MutationObserver((mutations) => {
              let container = document.querySelector("#container-recommended-products-desktop");
              if (container && container.children.length >= 3) {
                this.setButtonLoading(false);
                
                if (cart && cart.classList.contains('is-empty')) {
                  cart.classList.remove('is-empty');
                }
                
                observer.disconnect();
              }
            });
            
            observer.observe(document.body, { 
              childList: true,
              subtree: true
            });
          } else {
            this.setButtonLoading(false);
          }
          
        } catch (error) {
          console.error('Error adding set to basket:', error);
          
          if (typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'addon-v2-system',
              error: error.message
            });
          }
          
          this.setButtonLoading(false);
        } finally {
          this.isSubmitting = false;
        }
      }
      
      resetAddonsToDefault() {
        this.isProgrammaticChange = true;
        this.addonSections.forEach(section => {
          // Reset all checkboxes: uncheck addons, check "none"
          section.querySelectorAll('.add-ons-v2__checkbox').forEach(checkbox => {
            checkbox.checked = checkbox.dataset.clearSelection === 'true';
          });
          
          // Reset slider position to the beginning
          const sliderList = section.querySelector('.add-ons-v2__items-list');
          if (sliderList) {
            sliderList.scrollTo({
              left: 0,
              behavior: 'smooth'
            });
          }
        });
        this.isProgrammaticChange = false;
        
        this.selectedAddons.clear();
        this.addonSections.forEach(section => {
          this.updateSectionHeader(section, null);
        });
        this.updateButtonText();
      }
      
      setButtonLoading(loading) {
        if (!this.mainProductButton) return;
        
        const spinner = this.mainProductButton.querySelector('.loading__spinner');
        
        if (loading) {
          this.mainProductButton.setAttribute('aria-disabled', 'true');
          this.mainProductButton.classList.add('loading');
          if (spinner) {
            spinner.classList.remove('hidden');
          }
        } else {
          this.mainProductButton.removeAttribute('aria-disabled');
          this.mainProductButton.classList.remove('loading');
          if (spinner) {
            spinner.classList.add('hidden');
          }
        }
      }
      
      getSectionId() {
        const mediaItem = document.querySelector('.product [data-media-id]');
        if (mediaItem) {
          const mediaId = mediaItem.getAttribute('data-media-id');
          const parts = mediaId.split('-');
          if (parts.length > 1 && /^\d+$/.test(parts[parts.length - 1])) {
            parts.pop();
            return parts.join('-');
          }
        }
        return 'product-gallery';
      }
    
      getModalId() {
        const existingModalOpener = document.querySelector('modal-opener[data-modal]');
        if (existingModalOpener) {
          const modalAttr = existingModalOpener.getAttribute('data-modal');
          return modalAttr.replace('#', '');
        }
        return `ProductModal-${this.getSectionId()}`;
      }
      
      showAddonImages(checkbox) {
        const section = checkbox.closest('[data-addon-type]');
        const enableImageSwitching = section?.dataset.enableImageSwitching === 'true';
        
        if (!enableImageSwitching) return;
      
        const productSetImageUrl = checkbox.dataset.productSetImage;
        
        if (!productSetImageUrl || ['', 'null', 'undefined'].includes(productSetImageUrl)) {
          this.showOriginalFirstImages();
          this.triggerMediaGallerySync(false);
          return;
        }
        
        this.removeProductSetImages();
      
        const existingImage = document.querySelector(`.product img[src="${productSetImageUrl}"]:not([data-addon-v2-injected])`);
        
        if (existingImage) {
          this.showExistingProductSetImage(existingImage);
        } else {
          this.injectProductSetImage(productSetImageUrl);
        }
        
        this.hideOriginalFirstImages();
        this.triggerMediaGallerySync(true);
        this.scrollGalleryToTop();
      }
    
      hideAddonImages() {
        const injectedElements = document.querySelectorAll('[data-addon-v2-injected="true"]');
        const hadInjectedImages = injectedElements.length > 0;
        
        this.removeProductSetImages();
        this.showOriginalFirstImages();
        
        try {
          window.productImages = document.querySelectorAll('.product__media-list .product__media-item');
        } catch (error) {
          console.error('Error updating productImages reference:', error);
        }
        
        this.triggerMediaGallerySync(false);
        
        if (hadInjectedImages) {
          this.scrollGalleryToTop();
        }
      }
    
      injectProductSetImage(imageUrl) {
        const sectionId = this.getSectionId();
        const modalId = this.getModalId();
        const timestamp = Date.now();
        const mediaId = `addon-v2-injected-${timestamp}`;
        
        const mainGallery = document.querySelector('.product__media-list');
        if (mainGallery) {
          const li = document.createElement('li');
          li.id = `Slide-${sectionId}-${mediaId}`;
          li.className = 'product__media-item grid__item slider__slide is-active';
          li.setAttribute('data-addon-v2-injected', 'true');
          li.setAttribute('data-media-id', `${sectionId}-${mediaId}`);
          
          li.innerHTML = `
            <div class="product-media-container media-type-image media-fit-cover global-media-settings gradient"
                 style="--ratio: 1.0; --preview-ratio: 1.0;">
              <modal-opener class="product__modal-opener product__modal-opener--image" data-modal="#${modalId}">
                <div class="loading__spinner hidden">
                  <svg class="spinner" viewBox="0 0 50 50">
                    <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                  </svg>
                </div>
                <div class="product__media media media--transparent">
                  <img src="${imageUrl}" 
                       alt="Product with selected addon" 
                       loading="eager"
                       class="image-magnify-hover"
                       onerror="this.closest('.product__media-item').style.display='none'; console.error('Failed to load addon image:', '${imageUrl}');"
                       style="object-fit: cover; object-position: center;" />
                </div>
                <button class="product__media-toggle quick-add-hidden"
                        type="button"
                        aria-haspopup="dialog"
                        data-media-id="${mediaId}">
                  <span class="visually-hidden">Open media 1</span>
                </button>
              </modal-opener>
            </div>
          `;
          
          mainGallery.insertBefore(li, mainGallery.firstChild);
        }
        
        const modalGallery = document.querySelector('.product-media-modal__content');
        if (modalGallery) {
          const div = document.createElement('div');
          div.id = `Slide-${sectionId}-modal-${mediaId}`;
          div.className = 'grid__item slider__slide';
          div.setAttribute('data-addon-v2-injected', 'true');
          div.setAttribute('data-cascade', '');
          div.style.cssText = '--animation-order: 1; height:100vh; display:flex !important;';
          
          div.innerHTML = `
            <img class="scrollBar global-media-settings global-media-settings--no-shadow"
                 src="${imageUrl}"
                 alt="Product with selected addon"
                 loading="eager"
                 width="1100"
                 height="1100"
                 onerror="this.closest('.slider__slide').style.display='none'; console.error('Failed to load addon modal image:', '${imageUrl}');"
                 data-media-id="${mediaId}" />
          `;
          
          modalGallery.insertBefore(div, modalGallery.firstChild);
        }
        
        const thumbnailGallery = document.querySelector('.thumbnail-list');
        if (thumbnailGallery) {
          const li = document.createElement('li');
          const thumbnailId = `Thumbnail-${sectionId}-addon-v2-${timestamp}`;
          
          li.id = `Slide-Thumbnails-${sectionId}-addon-v2-${timestamp}`;
          li.className = 'thumbnail-list__item slider__slide';
          li.setAttribute('data-addon-v2-injected', 'true');
          li.setAttribute('data-target', `${sectionId}-${mediaId}`);
          li.setAttribute('data-media-position', '1');
          
          li.innerHTML = `
            <button class="thumbnail global-media-settings global-media-settings--no-shadow"
                    type="button"
                    aria-label="Load image 1"
                    aria-current="true"
                    aria-controls="GalleryViewer-${sectionId}"
                    aria-describedby="${thumbnailId}">
              <img id="${thumbnailId}"
                   src="${imageUrl}"
                   alt="Product with selected addon"
                   loading="eager"
                   onerror="this.closest('.thumbnail-list__item').style.display='none';" />
            </button>
          `;
          
          thumbnailGallery.insertBefore(li, thumbnailGallery.firstChild);
          
          const mediaGallery = document.querySelector('media-gallery');
          if (mediaGallery) {
            const button = li.querySelector('button');
            if (button) {
              button.addEventListener('click', () => {
                if (typeof mediaGallery.setActiveMedia === 'function') {
                  mediaGallery.setActiveMedia(`${sectionId}-${mediaId}`, false);
                }
              });
            }
          }
        }
      }
    
      showExistingProductSetImage(imgElement) {
        const containers = [
          { selector: '.product__media-list', parentSelector: '.product__media-item' },
          { selector: '.product-media-modal__content', parentSelector: '.grid__item.slider__slide' },
          { selector: '.thumbnail-list', parentSelector: '.thumbnail-list__item.slider__slide' }
        ];
      
        containers.forEach(({ selector, parentSelector }) => {
          const container = document.querySelector(selector);
          if (!container) return;
          
          const injectedItems = container.querySelectorAll(`${parentSelector}[data-addon-v2-injected="true"]`);
          
          injectedItems.forEach(item => {
            const itemImg = item.querySelector('img');
            if (itemImg && itemImg.src === imgElement.src) {
              container.insertBefore(item, container.firstChild);
              item.classList.remove('hidden');
              if (selector === '.product-media-modal__content') {
                item.style.setProperty('display', 'flex', 'important');
              } else {
                item.style.display = '';
              }
              
              if (selector === '.thumbnail-list') {
                const button = item.querySelector('button');
                if (button) {
                  button.setAttribute('aria-current', 'true');
                }
              }
            }
          });
        });
      }
    
      removeProductSetImages() {
        const injectedElements = document.querySelectorAll('[data-addon-v2-injected="true"]');
        injectedElements.forEach(element => element.remove());
      }
    
      scrollGalleryToTop() {
        requestAnimationFrame(() => {
          const mainGallery = document.querySelector('.product__media-list');
          
          if (mainGallery) {
            mainGallery.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }

          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        });
      }
    
      toggleOriginalFirstImages(show) {
        const containers = [
          { selector: '.product__media-list', parentSelector: '.product__media-item' },
          { selector: '.product-media-modal__content', parentSelector: '.grid__item.slider__slide' },
          { selector: '.thumbnail-list', parentSelector: '.thumbnail-list__item.slider__slide' }
        ];
      
        containers.forEach(({ selector, parentSelector }) => {
          const container = document.querySelector(selector);
          if (!container) return;
          
          const firstOriginal = container.querySelectorAll(parentSelector + ':not([data-addon-v2-injected])')[0];
          if (!firstOriginal) return;
          
          if (show) {
            container.insertBefore(firstOriginal, container.firstChild);
            firstOriginal.classList.remove('hidden');
            const displayValue = selector === '.product-media-modal__content' ? 'flex' : 'block';
            firstOriginal.style.setProperty('display', displayValue, 'important');
          } else {
            firstOriginal.classList.add('hidden');
            firstOriginal.style.setProperty('display', 'none', 'important');
          }
          
          if (selector === '.thumbnail-list') {
            const button = firstOriginal.querySelector('button');
            if (button) button.setAttribute('aria-current', show ? 'true' : 'false');
          }
        });
      }
      
      hideOriginalFirstImages() {
        this.toggleOriginalFirstImages(false);
      }
    
      showOriginalFirstImages() {
        this.toggleOriginalFirstImages(true);
      }
    
      triggerMediaGallerySync(hasMatchingImage = false) {
        const windowWidth = window.innerWidth;
        if(windowWidth > 749) return;

        const mediaGallery = document.querySelector('media-gallery');
        if (!mediaGallery) return;
        
        const firstVisibleImage = document.querySelector('.product__media-item:not(.hidden)');
        if (!firstVisibleImage) return;
        
        const mediaId = firstVisibleImage.dataset.mediaId;
        if (!mediaId) return;
        
        requestAnimationFrame(() => {
          if (typeof mediaGallery.setActiveMedia === 'function') {
            mediaGallery.setActiveMedia(mediaId, false, false);
          }
          
          if (mediaGallery.elements && mediaGallery.elements.viewer) {
            const sliderComponent = mediaGallery.elements.viewer.closest('slider-component-laurajames');
            if (sliderComponent && typeof sliderComponent.resetPages === 'function') {
              sliderComponent.resetPages();
            }
            
          const slideChangedEvent = new CustomEvent('slideChanged', {
            detail: {
                currentElement: firstVisibleImage
              }
            });
            mediaGallery.elements.viewer.dispatchEvent(slideChangedEvent);
          }
        });
      }
    }
  );
}
